/**
 * Överenskommelse om avstående från besittningsskydd – Lokal — composition.
 *
 * Connected under a lokalhyresavtal. Landlord, tenant and an eventual
 * co-tenant sign; the executed form goes to hyresnämnden outside Regta when
 * approval is required.
 */
import { COMPOSITION_SCHEMA, COMPOSITION_VERSION } from '@hyranai/regta-document-ir';
const TITLE = 'Överenskommelse om avstående från besittningsskydd – Lokal';
const FORM_NUMBER = 'Formulär R-15';
const KEY = 'avstaende_besittningsskydd_lokal';
export const avstaendeBesittningsskyddLokalV1 = (values = {}) => ({
    schema: COMPOSITION_SCHEMA,
    version: COMPOSITION_VERSION,
    documentKey: KEY,
    documentVersion: 'v1',
    title: TITLE,
    locale: 'sv-SE',
    meta: {
        category: 'Lokalhyra',
        shortTitle: 'Avstående besittningsskydd (lokal)',
        formNumber: FORM_NUMBER,
        signingMode: 'digital',
        signingPlacementAnchors: 'per-party-label',
        status: 'active',
        preamble: 'Ansökan till hyresnämnd om godkännande av överenskommelse mellan hyresvärd och lokalhyresgäst om att hyresgästen avstår från sitt indirekta besittningsskydd (12 kap. 57–60 §§ jordabalken).',
        description: 'Avtal om att lokalhyresgästen avstår från sitt indirekta besittningsskydd (12 kap. 57–60 §§ jordabalken). Motsvarar hyresnämndens blankett HN3 och utgör samtidigt ansökan till hyresnämnden.',
        statute: '12 kap. 57–60 §§ jordabalken',
        numberStyle: 'paragraph',
        partySlots: [
            { id: 'lessor', label: 'Hyresvärd', signingLabel: 'Hyresvärd / Uthyrare', role: 'lessor', ordinal: 0, required: true, signs: true },
            { id: 'lessee_primary', label: 'Hyresgäst (primär)', signingLabel: 'Hyresgäst', role: 'lessee', ordinal: 0, required: true, signs: true },
            {
                id: 'lessee_co',
                label: 'Medhyresgäst',
                signingLabel: 'Eventuell medhyresgäst',
                role: 'lessee',
                ordinal: 1,
                signs: true,
                help: 'Valfritt — lägg till om lokalen hyrs av flera hyresgäster.',
            },
        ],
        propertySlots: [{ id: 'property', label: 'Fastighet', multi: false, required: true }],
        connectedTo: ['lokalhyra'],
        inheritFromParent: {
            parties: 'by-role-ordinal',
            property: true,
            values: [{ key: 'lease_access_date', fromParentKey: 'lease_start_date' }],
        },
        titleSuffix: { key: 'property_designation', prefix: '' },
    },
    values,
    blocks: [
        { instanceId: 'letterhead', blockRef: 'common.letterhead@v1', slot: 'letterhead', input: { title: TITLE, form_number: FORM_NUMBER } },
        { instanceId: 'footer', blockRef: 'common.page-footer@v1', slot: 'footer', input: { form_number: FORM_NUMBER } },
        { instanceId: 'rubrik', blockRef: `${KEY}.rubrik@v1`, input: {} },
        { instanceId: 'hyresvard', blockRef: `${KEY}.hyresvard@v1`, input: {} },
        { instanceId: 'hyresgaster', blockRef: `${KEY}.hyresgaster@v1`, input: {} },
        { instanceId: 'lokalen', blockRef: `${KEY}.lokalen@v1`, input: {} },
        { instanceId: 'hyresavtalet', blockRef: `${KEY}.hyresavtalet@v1`, input: {} },
        { instanceId: 'overenskommelsens-innehall', blockRef: `${KEY}.overenskommelsens-innehall@v1`, input: {} },
        { instanceId: 'ansokan', blockRef: `${KEY}.ansokan@v1`, input: {} },
        { instanceId: 'underskrift', blockRef: `${KEY}.underskrift@v1`, input: {} },
        { instanceId: 'hyresnamndens-beslut', blockRef: `${KEY}.hyresnamndens-beslut@v1`, input: {} },
        { instanceId: 'information', blockRef: `${KEY}.information@v1`, input: {} },
    ],
});
//# sourceMappingURL=avstaende_besittningsskydd_lokal.js.map